import skeletonClasses from "@mui/material/Skeleton/skeletonClasses";
import typographyClasses from "@mui/material/Typography/typographyClasses";
export const MuiSkeletonTheme = (dt) => {
    return {
        defaultProps: {},
        styleOverrides: {
            root: {
                backgroundColor: dt.color.surface.variant,
                [`&.${skeletonClasses.rounded}`]: {
                    borderRadius: dt.brand.borderRadius.small,
                },
                [`&.${typographyClasses.root} &.${skeletonClasses.rounded}`]: {
                    borderRadius: dt.brand.borderRadius.xSmall,
                },
            },
        },
    };
};
